<template>
  <AppFormGroup>
    <SubHeading keypath="headings.identification" />

    <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      <AppField :path-prefix="applicantType" path="identity.type" />
      <AppField :path-prefix="applicantType" path="identity.number" />
      <AppField :path-prefix="applicantType" path="identity.state" />
      <AppField :path-prefix="applicantType" path="identity.expirationDate" />
    </div>
  </AppFormGroup>
</template>

<script setup lang="ts">
  import {
    AppField,
    AppFormGroup,
  } from "@versatile-credit-apply/components/form"
  import { useProviderI18n } from "@versatile-credit-apply/sdk"
  import type { FormSectionProps } from "./form-section-api"

  const props = defineProps<FormSectionProps>()

  useProviderI18n(() => props.providerKey)
</script>

<i18n lang="yaml" locale="en">
appFields:
  # ID Fields
  primaryIdentityExpirationDate:
    label: Expiration Date
  primaryIdentityNumber:
    label: ID Number
  primaryIdentityState:
    label: ID State
  primaryIdentityType:
    label: ID Type
headings:
  identification: Identification
</i18n>
